const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`main_id`] = (((context.has(`main_id`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`main_id`) ? context.get(`main_id`) : null), `main`])) : (`main`));
                context.proxy[`_main_href`] = (`#` + (context.has(`main_id`) ? context.get(`main_id`) : null));
                this.echo(`
<div class="c-sky-nav js-sky-nav`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  `);
                this.echo(`  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, 6, 115), new Map([[`class`, `c-sky-nav__skip`], [`href`, (context.has(`_main_href`) ? context.get(`_main_href`) : null)]]), false, false, 6));
                this.echo(`  `);
                this.echo(`  <header class="c-sky-nav__content"`);
                if ((context.has(`include_role`) ? context.get(`include_role`) : null)) {
                    this.echo(` role="banner"`);
                }
                this.echo(`>
    <div class="c-sky-nav__masthead">
      <a class="c-sky-nav__logo" href="/"`);
                if ((context.has(`is_home`) ? context.get(`is_home`) : null)) {
                    this.echo(` aria-current="page"`);
                }
                this.echo(`>
        `);
                this.echo(`        <span class="u-hidden-visually">Home: Cloud Four</span>
        `);
                this.echo(`        <svg class="c-sky-nav__logo-object"
          width="72" height="54" viewBox="0 0 540 405"
          focusable="false">
          <path class="c-sky-nav__logo-outline" d="M522,222.27c0-56.15-29.26-86.06-53.77-101.27a143.05,143.05,0,0,0-47-18.32,136.88,136.88,0,0,0-38.78-40.13,172.65,172.65,0,0,0-45.52-21.86,225,225,0,0,0-65.42-10.32c-1.68,0-2.82,0-3.33.05-33.55,0-63.06,5.63-87.72,16.67-20.21,9-37.2,21.71-50.48,37.64a126.67,126.67,0,0,0-25.32,48.67,168.25,168.25,0,0,0-39.44,22.17C34.32,179.13,18,210.4,18,246c0,50.48,26.12,88.79,75.52,110.79,34.93,15.54,69.42,17.44,72.62,17.59,1,.06,5.12.31,11.63.31,21.17,0,74.58-2.73,126.06-27.23a105.14,105.14,0,0,0,56.7,16.43c1.41,0,2.85,0,4.26-.08s2.92.09,4.37.09a103.41,103.41,0,0,0,68.15-25.51C473,331.32,499,309.12,512.47,274A147.44,147.44,0,0,0,522,222.27Z" fill="none" stroke-miterlimit="10" stroke-width="24"/>
          <path d="M165,264.82a87.23,87.23,0,0,1-38.2-45.8,37.25,37.25,0,0,1,10.4-20c9.6-11,121.4-132.6,168.8-153.4a233.3,233.3,0,0,0-37.6-3.2c-140,0-153.4,100-153.4,100s-85,26-85,103.6c0,111,136.8,116.4,136.8,116.4a307,307,0,0,0,43.2-1.6,25.81,25.81,0,0,0,17.8-14.2c8.2-20,20-51.8,31.6-85.2C214,263.62,170,265.82,165,264.82Z"/>
          <path d="M510,222.42c0-98.2-96.2-108.8-96.2-108.8a122.12,122.12,0,0,0-42.8-44c-8.6,30.6-30.8,112.2-32,127.6h33.6s5.4,0,4,6.6c-3.2,15-11.6,51.6-29.6,52.8l-23.6,1.4c-6.6,27-13.6,55.2-18.6,75.6a94,94,0,0,0,60,18.2,91.81,91.81,0,0,0,67-24.6C512.79,313.62,510,222.42,510,222.42Z"/>
          <path d="M307.79,99.62A846.59,846.59,0,0,0,208,202.42l72.2-2.8c14.8-41.6,27.6-78.6,33.2-94.8A6,6,0,0,0,307.79,99.62Z"/>
        </svg>
      </a>
    </div>
    <nav class="c-sky-nav__menu" aria-labelledby="menu-label">
      <h2 id="menu-label" class="u-hidden-visually">
        Main Menu
      </h2>
      `);
                this.echo(`      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, 44, 116), new Map([[`class`, `c-sky-nav__menu-toggle js-sky-nav-menu-toggle`]]), false, false, 44));
                this.echo(`      `);
                this.echo(`      <ul class="c-sky-nav__menu-items" role="list">
        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 58, this.source)(this.env, (context.has(`menu`) ? context.get(`menu`) : null), `items`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`          <li class="c-sky-nav__menu-item">
            <a class="c-sky-nav__menu-action"
              href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(61, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 61, this.source)(this.env, context.get(`item`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`"
              `);
                    if (this.traceableMethod(this.getAttribute, 62, this.source)(this.env, context.get(`item`), `current`, new Map([]), `any`, false, false, false)) {
                        this.echo(`                aria-current="page"
              `);
                    }
                    this.echo(`>
              <span class="c-sky-nav__menu-label">
                `);
                    this.echo(this.env.getFilter('escape').traceableCallable(66, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 66, this.source)(this.env, context.get(`item`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
              </span>
            </a>
          </li>
        `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      </ul>
    </nav>
  </header>
</div>

`);
                if ((context.has(`include_main_demo`) ? context.get(`include_main_demo`) : null)) {
                    this.echo(`  <main class="o-container o-container--pad" id="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(84, this.source)(...[this.env, (context.has(`main_id`) ? context.get(`main_id`) : null), `html`, null, true]));
                    this.echo(`">
    <div class="o-container__content">
      <p>Hello world! This is the main content.</p>
    </div>
  </main>
`);
                }
            }

            getTemplateName() {
                return `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, ``);
            }
        }],
        [115, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, 6);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      Skip to main content
    `);
            }

            getTemplateName() {
                return `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, ``);
            }
        }],
        [116, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, 44);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          <span class="u-hidden-visually">Toggle Main</span>
          Menu
        `);
            }

            getTemplateName() {
                return `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42');

let template = env.loadTemplate('8182672155912846d8e2f8b621be08671578c6f4418ce1dc61599a2821be4a42');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/sky-nav/sky-nav.twig", args: context }
     );
     return rendered;;
};